import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import EntryGrid from "./components/EntryGrid";
import TagWall from "./components/TagWall";
import HeatRank from "./components/HeatRank";
import FeaturedBoards from "./components/FeaturedBoards";
import NewsFeed from "./components/NewsFeed";
import Directory from "./components/Directory";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <EntryGrid />
        <TagWall />
        <HeatRank />
        <FeaturedBoards />
        <NewsFeed />
        <Directory />
      </main>
      <Footer />

      {/* back to top */}
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-5 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-none hover:bg-primary-600 md:right-8"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}